import { Label } from '@lib/label';

import { User, UserEntraId, UserLdap } from '../model';

export class UserMapper {
  public static map(userData: any): User {
    return userData
      ? new User(
        userData.id,
        userData.firstName,
        userData.lastName,
        userData.username,
        userData.email,
        userData.phoneNumber,
        userData.vip,
        userData.createdAt,
        userData.account,
        userData.hasActiveActivation,
        userData.superAdmin,
        userData.type,
        userData.ldap ? new UserLdap(userData.ldap.id, userData.ldap.name) : null,
        userData.azure ? new UserEntraId(userData.azure.id, userData.azure.name) : null,
        userData.locked,
        userData.labels ? userData.labels.map(({ id, name, color, directory }) => new Label(id, name, color, directory)) : [],
        userData.hasLocalPassword ?? false
      )
      : null;
  }
}
